import { setLevel, addAppender, logLevel } from '@fileee/logger';
import { FileeeLogAppender } from './fileee-log-appender';

export function setupLogging() {
  setLevel(logLevel.info);
  addAppender(new FileeeLogAppender());
}
